import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconClose.css';

const IconClose = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
  <svg
    className={classes}
    width="21"
    height="21"
    viewBox="0 0 21 21"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 4L4 16" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 4L16 16" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
  );
};

const { string } = PropTypes;

IconClose.defaultProps = {
  className: null,
  rootClassName: null,
};

IconClose.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconClose;
